import http from './http';

const getCurrentSession = () => {
    return http.get('/public/session/current-session');
};

export default {
    getCurrentSession,
};
